import React from 'react';
import { Chip } from '@mui/material';

const Badge = ({ bg = 'primary', text, pill, children, as = 'span', className = '', ...props }) => (
  <Chip component={as} size="small" variant="outlined" className={'sugi-status-chip ' + className}
    color={({ danger: 'error', secondary: 'default', light: 'default', dark: 'default' })[bg] || bg}
    label={children} {...props} />
);
export default Badge;
